import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

/**
 * A wrapper component that redirects to the home page if the user is not an admin
 */
const AdminRoute = ({ children }) => {
  const { currentUser, isAdmin, loading } = useAuth();

  // If still loading auth state, show nothing (or could show a spinner)
  if (loading) {
    return <div className="text-center p-5"><div className="spinner-border" role="status"></div></div>;
  }

  // If not authenticated, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  // If authenticated but not admin, redirect to unauthorized page or home
  if (!isAdmin) {
    return <Navigate to="/unauthorized" />;
  }

  // If authenticated and admin, render the protected content
  return children;
};

export default AdminRoute;